// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"categoryNav_sliderWrapper__dwkGV","sliderNav":"categoryNav_sliderNav__H93nS","hover":"categoryNav_hover__YWqMQ"};